import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ESRI, GIS, GOOGLE } from '@rsos/maps/constants/reverseGeocodeServices';
import { selectGeocodeService } from '@rsos/reduxDataStore';
import checkGISServicesAccess from '@rsos/utils/checkGISServicesAccess';
import usePortalType from '@rsos/utils/usePortalType';

/**
 * Determines which reverse geocode service to use based on capabilities and permissions.
 * Possible values: gis, esri, or google.
 */
const useWhichReverseGeocodeService = () => {
  const [service, setService] = useState('');

  const { isPremiumUser } = usePortalType();

  const hasGISServicesAccess = useSelector(state =>
    checkGISServicesAccess({
      psaps: state.psaps,
      sinatra: state.sinatra,
    }),
  );

  const hasGISGeocodeService = useSelector(
    state => !!selectGeocodeService(state),
  );

  // Reverse geocoding service priority list: local GIS > Esri > Google
  useEffect(() => {
    if (hasGISServicesAccess && hasGISGeocodeService) setService(GIS);
    else if (isPremiumUser) setService(ESRI);
    else setService(GOOGLE);
  }, [hasGISGeocodeService, hasGISServicesAccess, isPremiumUser]);

  return service;
};

export default useWhichReverseGeocodeService;
